import { cn } from "@/lib/utils";

interface LoadingSkeletonProps {
  className?: string;
  variant?: "text" | "circular" | "rectangular" | "card";
  lines?: number;
}

export const LoadingSkeleton = ({ 
  className, 
  variant = "rectangular",
  lines = 1 
}: LoadingSkeletonProps) => {
  const baseClasses = "animate-pulse bg-muted rounded";

  if (variant === "text") {
    return (
      <div className={cn("space-y-2", className)}>
        {Array.from({ length: lines }).map((_, i) => (
          <div 
            key={i} 
            className={cn(
              baseClasses, 
              "h-4",
              i === lines - 1 ? "w-3/4" : "w-full"
            )} 
          />
        ))}
      </div>
    );
  }

  if (variant === "circular") {
    return (
      <div 
        className={cn(baseClasses, "rounded-full w-12 h-12", className)} 
      />
    );
  }

  if (variant === "card") {
    return (
      <div className={cn("p-4 rounded-lg border border-border", className)}>
        <div className={cn(baseClasses, "h-32 w-full mb-4")} />
        <div className={cn(baseClasses, "h-4 w-3/4 mb-2")} />
        <div className={cn(baseClasses, "h-4 w-1/2")} />
      </div>
    );
  }

  return (
    <div className={cn(baseClasses, "h-20 w-full", className)} />
  );
};

// Section loading skeleton
export const SectionSkeleton = ({ className }: { className?: string }) => (
  <section className={cn("py-20", className)} aria-busy="true" aria-label="Chargement...">
    <div className="container mx-auto px-6">
      <div className="animate-pulse">
        <div className="h-8 w-48 bg-muted rounded mb-8" />
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <LoadingSkeleton key={i} variant="card" />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default LoadingSkeleton;
